<template>
  <div
    v-if="visible"
    class="inner-loader__overlay"
    :class="{
      'inner-loader__overlay--transparent': props.transparent,
    }"
    :style="{
      minHeight: props.size,
      minWidth: props.size,
      width: '100%',
      height: '100%',
    }"
    @click.stop
  >
    <lottie-animation
      v-if="!props.noSpinner"
      ref="spinnerRef"
      name="DevStride Loader"
      :path="dsSpinOnce"
      path-is-animation-data
      :size="props.size"
      loop
    />
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import LottieAnimation from './icons/LottieAnimation.vue';
// we're inlining this because inner-loader is used all over the place and causes way too many requests if we use path
import dsSpinOnce from './icons/lottie-animations/ds-spin-once.json?raw';
const props = withDefaults(
  defineProps<{
    size?: string;
    visible?: boolean;
    noSpinner?: boolean;
    transparent?: boolean;
  }>(),
  {
    size: '70px',
    noSpinner: false,
  }
);
</script>

<style lang="scss" scoped>
.inner-loader__overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  @apply tw-cursor-wait tw-flex tw-flex-col tw-items-center tw-justify-center;
}

.inner-loader__overlay--transparent {
  @apply tw-bg-transparent tw-bg-opacity-0;
}
</style>
